module.exports = __webpack_public_path__ + "media/12_10.38acac13.wav";